import { render, staticRenderFns } from "./ProfileSubscriptionSlider.vue?vue&type=template&id=1bc6bb0e&"
import script from "./ProfileSubscriptionSlider.vue?vue&type=script&lang=js&"
export * from "./ProfileSubscriptionSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports